/*
 This "cache" maintains objects in memory for a period of time. Serverless wipes out modules after handling a
 request, so storing a local dictionary wouldn't help us -- that's why we store on `global`.
 */
export function getGlobalMap<T>(key: string, defaultValue?: T): T {
  /* istanbul ignore else */
  if (global[key] === undefined) {
    global[key] = defaultValue || {};
  }
  return global[key];
}

export function resetGlobalMap<T>(key: string): T {
  global[key] = {};
  return global[key];
}
